export const styles = theme => ({
  root: {
    marginTop: theme.spacing(2),
    padding : theme.spacing(3),
    width : '100%',
    boxSizing: 'border-box'
  },
  container: {
    // display: 'flex',
    // flexWrap: 'wrap',
    // marginBottom : '8px',
  },
  title : {
    fontSize : '1.5rem',
  },
  textField: {
    marginRight: theme.spacing(1),
    width: '100%',    
  },
  inputType: {
    height: 'unset'
  },
  menu: {
    textTransform: 'capitalize'
  },
  input : {

  },
  label : {
    fontWeight :410
  },
  button: {
    float: 'right',
  },   
  dateTimePicker: {
    width: '100%',
    ' + div' :{
      width: '100%',
    }
  },
  containerImage : {
      paddingTop: '56.25%',
      height: 0,
      // border: '2px solid #F2F2F2',
      boxShadow :'0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);',
      margin: '20px 0px',
      backgroundSize : 'cover',
      backgroundPosition : 'center',
      cursor: 'pointer',
  },
  wrapSelected: {
    paddingTop: '16px !important',
  },
  MultiSelect: {
    padding: '0px',
    flexGrow: '0',
  },
  selectedMenu: {
    '&:focus': {
      backgroundColor: 'transparent',
    }
  },
});